import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class IncomeClassificationType  {
    _originalTypeClassName = "zERP.BO.IncomeClassificationType";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
IncomeClassificationType.translate = translateService;
}
this.GetClassificationType = null;
this.GetClassificationCategory = null;
this.Id = null;
this.Amount = null;
this.ERPAA = null;
this.ERPDocID = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
GetClassificationType:any;
GetClassificationCategory:any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Amount:any;
ERPAA:any;
ERPDocID:any;
InvoicesIncomeClassificationDetailType:any;
ClassificationType:any;
ERPInvoiceCategory:any;
ERPInvoiceType:any;
ClassificationCategory:any;
InvoiceSummaryType:any;
static setInvoicesIncomeClassificationDetailType = ($this, value) => {
var oldValue = $this.InvoicesIncomeClassificationDetailType;
$this.InvoicesIncomeClassificationDetailType = value;
if (value != null) {
if (oldValue != null) {
Domain.InvoicesIncomeClassificationDetailType.removeIncomeClassificationDetailData(oldValue, $this);
}
Domain.InvoicesIncomeClassificationDetailType.addIncomeClassificationDetailData(value, $this);
}
}
static setClassificationType = ($this, value) => {
var oldValue = $this.ClassificationType;
$this.ClassificationType = value;
if (value != null) {
}
}
static setERPInvoiceCategory = ($this, value) => {
var oldValue = $this.ERPInvoiceCategory;
$this.ERPInvoiceCategory = value;
if (value != null) {
}
}
static setERPInvoiceType = ($this, value) => {
var oldValue = $this.ERPInvoiceType;
$this.ERPInvoiceType = value;
if (value != null) {
}
}
static setClassificationCategory = ($this, value) => {
var oldValue = $this.ClassificationCategory;
$this.ClassificationCategory = value;
if (value != null) {
}
}
static setInvoiceSummaryType = ($this, value) => {
var oldValue = $this.InvoiceSummaryType;
$this.InvoiceSummaryType = value;
if (value != null) {
if (oldValue != null) {
Domain.InvoiceSummaryType.removeIncomeClassification(oldValue, $this);
}
Domain.InvoiceSummaryType.addIncomeClassification(value, $this);
}
}

static GetGetClassificationType($this: any): any{if ($this?.ClassificationType == null) {return "";}
let index = $this?.ClassificationType?.Description?.indexOf(" ");
return $this?.ClassificationType?.Description?.substr(0, index);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}